import { Injectable } from "@angular/core";


type Constructor<T> = new (...args: any[]) => T;


@Injectable()
export class ComponentRegistryService {

  private readonly _registry = new Map<Constructor<any>, any>();

  register<T>(constructor: Constructor<T>, component: T): void {
    this._registry.set(constructor, component);
  }

  unregister<T>(constructor: Constructor<T>): void {
    this._registry.delete(constructor);
  }

  get<T>(constructor: Constructor<T>): T | undefined {
    return this._registry.get(constructor);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/services/component-registry.service.ts